<template>
  <section class="form-box">
    <!-- Action buttons  -->
    <FloatingActionButtons
      :box="box"
      :index="index"
      :computedBoxesData="boxes"
      :activeFABIndex="activeFABIndex"
      @passActiveIndex="$emit('passActiveIndex', $event)"
      @showDeleteModal="showDeleteModal"
      @showEditModal="showEditModal"
      @showVisibilityModal="showVisibilityModal"
    />

    <!-- Box  -->
    <div class="form-wrapper">
      <div
        class="form-image"
        :style="{
          'background-image': `linear-gradient(0deg, rgba(255, 255, 255, 0.1) -15%, ${box.formColor} 95%), url(${box.backgroundImage})`,
        }"
      ></div>
      <div class="form-title h4" :style="{ color: box.textColor }">
        {{ secondLanguage ? box.titleSec : box.title }}
      </div>
      <div class="form-table">
        <div class="form-table__item">
          <div class="form-table__item--checkbox">
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                :fill="box.textColor"
                d="M30.625 0H4.375C1.96875 0 0 1.96875 0 4.375V30.625C0 33.0312 1.96875 35 4.375 35H30.625C33.0312 35 35 33.0312 35 30.625V4.375C35 1.96875 33.0312 0 30.625 0ZM15.3125 27.1556L7.20344 19.0466L10.2966 15.9534L15.3125 20.9694L25.7972 10.4847L28.8903 13.5778L15.3125 27.1556Z"
              />
            </svg>
          </div>
          <div
            class="form-table__item--line"
            :style="{ 'background-color': box.textColor }"
          ></div>
        </div>
        <div class="form-table__item">
          <div
            class="form-table__item--checkbox-inactive"
            :style="{ 'border-color': box.textColor }"
          ></div>
          <div
            class="form-table__item--line"
            :style="{ 'background-color': box.textColor }"
          ></div>
        </div>
      </div>
      <div class="form-button">
        <button
          class="gbBtn"
          :style="{ color: box.formColor, background: box.textColor }"
        >
          <div class="gbBtn-text">
            <span v-if="secondLanguage">{{
              box.buttonTextSec || "SEE OUR SELECTION"
            }}</span>
            <span v-else>{{ box.buttonText || "SEE OUR SELECTION" }}</span>
          </div>
          <v-icon
            class="gbBtn-bell"
            name="concierge-bell"
            scale="1.5"
            style="align-self: center"
          ></v-icon>
        </button>
      </div>

      <!-- Modals  -->
      <VisibilityModal
        @close="closeWithNo()"
        @editVisibility="editVisibility"
        :box="box"
        v-if="visibilityModalVisible"
      />
      <transition name="fadeInModal">
        <FormBoxEdit
          :initialEditModal="initialEditModal"
          :box="box"
          :selectedBoxIndex="index"
          :completeBoxArray="boxes"
          :style="{ zIndex: '99' }"
          @close="closeEditModal"
          @deleteUneditedForm="deleteBox(index)"
          @formModalEditable="$emit('formModalEditable')"
          @showVisibilityModal="showVisibilityModal"
          v-if="showStandardEditModal"
        >
        </FormBoxEdit>
      </transition>
      <transition name="fadeInModal">
        <confirm-modal
          @yes="closeWithYes()"
          @no="closeWithNo()"
          v-if="showConfirmModal"
        >
          <h2 slot="title">Delete Box?</h2>
          <p slot="description">The box and its content will be deleted</p>
        </confirm-modal>
      </transition>
    </div>
  </section>
</template>

<script>
import FloatingActionButtons from "../../BoxesComponents/FloatingActionButtons";
import FormBoxEdit from "./FormBoxEdit";
import ConfirmModal from "@/components/GlobalComponents/ConfirmModal.vue";
import VisibilityModal from "@/components/EditGuestbookPage/BoxesComponents/VisibilityModal.vue";
import bus from "@/bus.js";
import { db, firestore } from "@/firebase";

export default {
  components: {
    FloatingActionButtons,
    FormBoxEdit,
    ConfirmModal,
    VisibilityModal,
  },
  props: {
    box: Object,
    index: Number,
    activeFABIndex: Number,
    boxes: Array,
    customFonts: Object,
    languageTypesIndex: Number,
    initialEditModal: Boolean,
  },
  data() {
    return {
      showStandardEditModal: this.initialEditModal,
      showConfirmModal: false,
      visibilityModalVisible: false,
      visibilityEdited: false,
    };
  },
  computed: {
    secondLanguage() {
      if (this.languageTypesIndex === 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    showDeleteModal() {
      this.showConfirmModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showEditModal() {
      this.showStandardEditModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showVisibilityModal() {
      this.visibilityModalVisible = true;
      this.visibilityEdited = false;
      this.$emit("toggleModal", true);
    },
    editVisibility(payload) {
      this.box.visibility = payload;
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/${this.index}`).set(this.box);

      let statisticsVisibility = [];
      if (payload.precheckin) {
        statisticsVisibility.push("precheckin");
      }
      if (payload.checkin) {
        statisticsVisibility.push("checkin");
      }
      if (payload.anonymous) {
        statisticsVisibility.push("anonymous");
      }

      firestore
        .collection("FormStatistics")
        .doc(this.$hotelId)
        .collection("Forms")
        .doc(this.box.id)
        .update({
          visibility: statisticsVisibility,
        });

      this.visibilityEdited = true;
    },
    closeEditModal() {
      this.showStandardEditModal = false;
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithYes: function () {
      this.showConfirmModal = false;
      this.deleteBox(this.index);
      this.$toastEvents.push({
        type: "copy",
        title: "Deletion",
        content: "The box has been deleted",
        id: +new Date(),
      });
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithNo: function () {
      if (this.showConfirmModal) {
        this.showConfirmModal = false;
      } else if (this.visibilityModalVisible) {
        this.visibilityModalVisible = false;
        if (this.visibilityEdited) {
          this.$toastEvents.push({
            type: "copy",
            title: "Visibility",
            content: "The visibility has been edited",
            id: +new Date(),
          });
        }
      }
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    deleteBox(boxIndex) {
      var newObjToFirebase = this.boxes;
      newObjToFirebase.splice(boxIndex, 1);
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(newObjToFirebase);
      if (!this.box.used) {
        firestore
          .collection("FormStatistics")
          .doc(this.$hotelId)
          .collection("Forms")
          .doc(this.box.id)
          .delete();
      } else {
        firestore
          .collection("FormStatistics")
          .doc(this.$hotelId)
          .collection("Forms")
          .doc(this.box.id)
          .update({
            visibility: "deleted",
          });
      }
    },
    routerPush: function (link) {
      window.open(`${link}`, "_blank");
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

@supports (-ms-ime-align: auto) {
  .form-table {
    margin-top: 25px;
  }
  .form-table__item--line {
    margin-left: 20px;
  }

  .form-table__item--checkbox {
    margin-left: 20px;
  }
  .form-table__item--checkbox-inactive {
    margin-left: 20px;
  }
}

.form-box {
  height: 100%;
}

.form-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

.form-image {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  z-index: 2;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.form-title {
  /* font-size: 20px; */
  height: 25%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
}

.form-table {
  display: flex;
  width: 290px;
  height: 50%;
  flex-direction: column;
  border-radius: 8px;
  display: flex;
  justify-content: space-evenly;
  z-index: 3;
}

.form-table__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.form-table__item--line {
  width: 200px;
  height: 6px;
}
.form-table__item--checkbox-inactive {
  width: 35px;
  height: 35px;
  border: 4px solid;
  border-radius: 5px;
}

.form-button {
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;
  text-align: center;
  z-index: 3;
}

.gbBtn {
  height: 45px;
  margin: auto;
  border: 2px solid transparent;
  width: calc(100% - 26px);
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
  overflow-x: hidden;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gbBtn-text {
  display: flex;
  font-size: 100%;
  justify-content: center;
  align-items: center;
}

.gbBtn-bell {
  position: relative;
  top: -2px;
  left: 30px;
}
</style>
